<br>
<br>
<h3 class="text-center">Are you sure ?</h3>
<br>
<p class="text-center">This action will change the status of associated <strong>ACTIVE </strong> Products</p>
<hr class="new5">
<div class="row">
    <div class="col-sm-4 mb-2 text-center">
        <div class="card">
            <div class="card-header">
                <h5>Product 1</h5>
            </div>
            <div class="card-body">
                <p>Data one</p>
                <p>Data two</p>
                <p>Data three</p>
                
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2 text-center">
        <div class="card">
            <div class="card-header">
                <h5>Product 2</h5>
            </div>
            <div class="card-body">
                <p>Data one</p>
                <p>Data two</p>
                <p>Data three</p>
                
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2 text-center">
        <div class="card">
            <div class="card-header">
                <h5>Product 3</h5>
            </div>
            <div class="card-body">
                <p>Data one</p>
                <p>Data two</p>
                <p>Data three</p>
                
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2 text-center">
        <div class="card">
            <div class="card-header">
                <h5>Product 4</h5>
            </div>
            <div class="card-body">
                <p>Data one</p>
                <p>Data two</p>
                <p>Data three</p>
                
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2 text-center">
        <div class="card">
            <div class="card-header">
                <h5>Product 5</h5>
            </div>
            <div class="card-body">
                <p>Data one</p>
                <p>Data two</p>
                <p>Data three</p>
                
            </div>
        </div>
    </div>
</div>
<div class="row d-flex">
    <div class="form-group col-md-12 text-right">
        <button class="btn btn-primary" (click)="saveProductSubcategoryModal()">Confirm</button>
        <button class="btn btn-secondary" id="cancelButton" (click)="closeModal()">Cancel</button>
    </div>
</div>
